import { useSearchParams } from 'react-router-dom';

export const useQuery = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getParam = (key: string) => {
    return searchParams.get(key);
  };

  const clearParams = () => {
    return setSearchParams(undefined);
  };
  return { getParam, clearParams };
};
